import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TocIcon(props: IconProps) {
    return <Icon {...props} iconKey={"toc"}/>
}
